import { unifySameDomainShape } from '../same-domain-unification';

type PuppyKernel = ReturnType<typeof import('../../../engine/loader').getPuppyKernel>;

/**
 * blend 求解结果同域归并输入。
 */
export interface BlendSameDomainUnificationInput {
  /** Puppy CAD 内核 实例。 */
  puppy: PuppyKernel;
  /** 需要归并同域面/边的 Shape。 */
  shape: unknown;
  /** 错误消息中的操作名称。 */
  operationLabel: string;
  /** 是否允许拼接相邻 BSpline 面。 */
  concatBSplines?: boolean;
}

/**
 * 对 blend 求解结果做同域面/边归并。
 *
 * 设计说明：
 * 1. 部分边线、变量圆角等求解会为了局部控制点生成中间分割拓扑；
 * 2. SolidWorks 的最终实体不会把这些内部求解段直接暴露成可见分割面；
 * 3. 因此同域归并属于几何管线的统一收口，而不是 UI 或渲染隐藏。
 *
 * @param input 归并输入。
 * @returns 归并后的 Shape；缺少绑定能力时返回原 Shape。
 */
export function unifyBlendSameDomainShape(input: BlendSameDomainUnificationInput): unknown {
  return unifySameDomainShape(input);
}

/**
 * 对部分边线求解结果做同域面/边归并。
 *
 * @param input 归并输入。
 * @returns 归并后的 Shape；缺少绑定能力时返回原 Shape。
 */
export function unifyPartialEdgeSameDomainShape(input: {
  puppy: PuppyKernel;
  shape: unknown;
  operationLabel: string;
}): unknown {
  return unifyBlendSameDomainShape({
    ...input,
    concatBSplines: false,
  });
}
